import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useTranslation } from "react-i18next";
import { namespace } from "@common-config/constants";

export type TimeFrame = 
    | '1h' | '2h' | '3h' | '6h' | '12h' 
    | '1d' | '2d' | '3d' | '1w' | '1m';

interface TimeFrameSelectorProps {
    value: TimeFrame;
    onValueChange: (value: TimeFrame) => void;
}

export function TimeFrameSelector({ value, onValueChange }: TimeFrameSelectorProps) {
    const { t } = useTranslation(namespace);
    return (
        <div className="w-[180px]">
             <label className="text-sm font-medium mb-1.5 block">{t('timeFrameSelector.label')}</label>
            <Select value={value} onValueChange={(val) => onValueChange(val as TimeFrame)}>
                <SelectTrigger>
                    <SelectValue placeholder={t('timeFrameSelector.placeholder')} />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="1h">{t('timeFrameSelector.lastHour')}</SelectItem>
                    <SelectItem value="2h">{t('timeFrameSelector.last2Hours')}</SelectItem>
                    <SelectItem value="3h">{t('timeFrameSelector.last3Hours')}</SelectItem>
                    <SelectItem value="6h">{t('timeFrameSelector.last6Hours')}</SelectItem>
                    <SelectItem value="12h">{t('timeFrameSelector.last12Hours')}</SelectItem>
                    <SelectItem value="1d">{t('timeFrameSelector.last24Hours')}</SelectItem>
                    <SelectItem value="2d">{t('timeFrameSelector.last2Days')}</SelectItem>
                    <SelectItem value="3d">{t('timeFrameSelector.last3Days')}</SelectItem>
                    <SelectItem value="1w">{t('timeFrameSelector.lastWeek')}</SelectItem>
                    <SelectItem value="1m">{t('timeFrameSelector.lastMonth')}</SelectItem>
                </SelectContent>
            </Select>
        </div>
    );
}
